export class AvailabilitySearchModel {
    arrivalDate!: Date;
    departureDate!: Date;
    includeOnlyWholeProperties?: boolean;
    ignoreRestrictions?: boolean;
    ignoreUnitTypeCount?: boolean;
    includeSpecialOffers?: boolean = true;
  
    cityId?: number;
    propertyName?: string;
  
    numberOfAdults?: number;
    numberOfChildren?: number;
    numberOfBedrooms?: number;
    numberOfBathrooms?: number;
    fromPrice?: number;
    toPrice?: number;
    distanceToBeach?: number;
    distanceToCityCenter?: number;

    numberOfUnits?: number;
  
    petsAllowed?: boolean;
    propertyTypes?: number[];
    categories?: number[];
    amenities?: number[];
  }

export interface AvailabilitySearchResult{
    propertyName: string;
    streetName: string;
    houseNumber: string;
    city: string;
    postalCode: string;
    accomodationUnitTypeId: number;
    accomodationUnitTypeName: string;
    totalNumberOfUnits: number;
    squareSize?: number;
    maxNumberOfAdults: number;
    maxNumberOfChildren: number;
    baseBedsCapacity: number;
    extraBedsCapacity: number;
    numberOfAvailableUnits: number;
    numberOfNights: number;

    ratesJSON: string;
    rates: Rate[];
}

export interface SimpleAvailabilitySearchResult{
    accommodationUnitId: number;
    accommodationUnitName: string;
    accommodationUnitTypeId: number;
    accommodationUnitTypeName: string;
    isAvailable: boolean;
    ownerId: number | null;
}

export interface Rate{
    accomodationUnitTypeId: number;
    ratePlanId: number;
    ratePlansAccomodationUnitTypeId: number;
    ratePlanName: string;
    isNonRefundable: boolean;
    includesBreakfast: boolean;
    isSpecialOrPackageOffer: boolean;
    totalPrice: number;
    averagePricePerNight: number;
    currencyId: number;

    isDefault: boolean;
    minPersons: number;
    maxPersons: number;
    minStay: number;
    maxStay: number;
}

export class SelectedAvailability{
    accomodationUnitTypeId!: number;
    
    accomodationUnitId?: number;
    ratePlanId?: number;
    ratePlansAccomodationUnitTypeId?: number;

    numberOfOccupants?: number;

    static GetFirstIndexInArray(array: SelectedAvailability[], item: AvailabilitySearchResult, rate: Rate): number{
        return array.findIndex(x => 
            x.accomodationUnitTypeId == item.accomodationUnitTypeId &&
            x.ratePlansAccomodationUnitTypeId == rate.ratePlansAccomodationUnitTypeId &&
            x.numberOfOccupants == item.maxNumberOfAdults
            );
    }

    static GetCountInArray(array: SelectedAvailability[], item: AvailabilitySearchResult, rate: Rate): number{
        return array.filter(x => 
            x.accomodationUnitTypeId == item.accomodationUnitTypeId &&
            x.ratePlansAccomodationUnitTypeId == rate.ratePlansAccomodationUnitTypeId &&
            x.numberOfOccupants == item.maxNumberOfAdults
            ).length;
    }
}